import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommonService } from 'wire-frame';


@Injectable({
  providedIn: 'root'
})
export class SupplierService {

  constructor(private http: HttpClient, private common: CommonService) { }

  getSupplier(payload: (string | null) = null) {
    return this.http.get(
      this.common.getBaseUrl() + 'Supplier.php?action=SupplierList' + (payload ? '&list=all' : '')
    );
  }

  addSupplier(payload: any) {
    // return this.http.post('/api/destinations', destination);
    payload["action"] = "addSupplier";
    return this.http.post(this.common.getBaseUrl() + 'Supplier.php', payload);
  }

  updateSupplier(payload: any) {
    payload["action"] = "updateSupplier";
    return this.http.put(this.common.getBaseUrl() + 'Supplier.php', payload);
  }

  deleteSupplier(payload: any) {
    payload["action"] = "deleteSupplier";
    return this.http.put(this.common.getBaseUrl() + 'Supplier.php', payload);
  }
}
